import React, { createContext, useContext, useEffect, useState } from 'react';
import ballotService from '../services/ballotService';
import { useBeta } from './BetaContext';

const BallotsContext = createContext(null);

export const BallotsProvider = ({ children }) => {
  const { activePartyId } = useBeta();
  const [ballots, setBallots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!activePartyId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = ballotService.subscribeToBallots(
      activePartyId,
      (data) => {
        setBallots(data);
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [activePartyId]);

  const value = {
    ballots,
    loading,
    error,
  };

  return (
    <BallotsContext.Provider value={value}>
      {children}
    </BallotsContext.Provider>
  );
};

export const useBallots = () => {
  const context = useContext(BallotsContext);
  if (!context) {
    throw new Error('useBallots must be used within a BallotsProvider');
  }
  return context;
};
